export default class FakeScroll {
  constructor(selector) {
    this.element = typeof selector === 'string' ? document.querySelector(selector) : selector;
    this.firstElement = this.element.firstElementChild;
    this.windowHeight = 0;
    this.scrollAmount = 0;
    this.vy = 0;
    this.enable = true;
    window.addEventListener('touchstart', (e) => {
      this._onTouchStart(e);
    });
    window.addEventListener('touchmove', (e) => {
      this._onTouchMove(e);
    }, { passive: false });
    window.addEventListener('touchend', (e) => {
      this._onTouchEnd(e);
    });
  }

  _onTouchStart(e) {
    if (this.enable === false || !this.element.contains(e.target)) {
      return;
    }
    this.vy = 0;
    this.firstElement.height = 'auto';
    this.oldPosY = this._getTouchPos(e).y;
  }

  _getLimitHeight() {
    const { firstElement, element } = this;
    const height = element.offsetHeight;
    // if ( height > window.innerHeight ) {

    // } else {

    // }
    let elHeight = firstElement.offsetHeight - height;
    elHeight += parseInt(window.getComputedStyle(firstElement).getPropertyValue('margin-top'), 10);
    elHeight += parseInt(window.getComputedStyle(firstElement).getPropertyValue('margin-bottom'), 10);
    return elHeight;
  }

  _onTouchMove(e) {
    if (this.enable === false || !this.element.contains(e.target)) {
      return;
    }

    e.preventDefault();
    const posY = this._getTouchPos(e).y;
    const y = posY - this.oldPosY;
    const limitHeight = this._getLimitHeight();
    if (limitHeight < 0) {
      return;
    }
    this.scrollAmount += y;
    if (this.scrollAmount < -limitHeight) {
      this.scrollAmount = -limitHeight;
    } else if (this.scrollAmount > 0) {
      this.scrollAmount = 0;
    }
    this.firstElement.style.transform = `translateY(${this.scrollAmount}px)`;
    this.oldPosY = posY;
    this.vy = y;
  }

  _onTouchEnd() {
    if (this.enable === false) {
      return;
    }
    const limitHeight = this._getLimitHeight();
    const registance = 0.4;

    const interval = () => {
      if (this.vy > 0) {
        this.vy -= registance;
      }
      if (this.vy < 0) {
        this.vy += registance;
      }
      if (Math.abs(this.vy) < registance) {
        return;
      }
      this.scrollAmount += this.vy;
      if (this.scrollAmount < -limitHeight) {
        this.scrollAmount = -limitHeight;
        this.firstElement.style.transform = `translateY(${this.scrollAmount}px)`;
        return;
      }
      if (this.scrollAmount > 0) {
        this.scrollAmount = 0;
        this.firstElement.style.transform = `translateY(${this.scrollAmount}px)`;
        return;
      }
      this.firstElement.style.transform = `translateY(${this.scrollAmount}px)`;
      window.requestAnimationFrame(interval);
    };
    window.requestAnimationFrame(interval);
  }

  _isTouched(e) {
    if (e && e.touches) {
      return true;
    }
    return false;
  }

  _getTouchPos(e) {
    let x = 0;
    let y = 0;
    e = typeof event === 'undefined' ? e : event;
    if (this._isTouched(e)) {
      x = e.touches[0].pageX;
      y = e.touches[0].pageY;
    } else if (e.pageX) {
      x = e.pageX;
      y = e.pageY;
    }
    return { x, y };
  }

  }
